<template>
    <div class="flex float-left vertical-center">
        <vs-chip class="line-0" v-bind:color="statusColor">
            {{statusText}}
        </vs-chip>
    </div>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "StatusProvisionAgridComponent",
        data() {
            return {
                statusColor: '',
                statusText: ''
            }
        },
        mounted() {
            if (this.params.value !== '' && this.params.value !== null && this.params.value !== undefined) {
                if (this.params.value === 'not provisioned') {
                    this.statusColor = 'dark'
                    this.statusText = 'Canceled'
                } else if (this.params.value === 'provisioned') {
                    this.statusColor = 'success'
                    this.statusText = 'Assigned'
                }
            }
            else {
                if (this.params.data.status_device === 'asign') {
                    this.statusColor = 'success'
                    this.statusText = 'Assigned'
                }else {
                    this.statusText = 'Pending'
                }
            }
        }
    })
</script>

<style scoped>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .line-0 {
        line-height: 0;
    }
</style>